import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home/index.js';
import AboutUs from './pages/AboutUs/index.js';
import ContactUs from './pages/ContactUs/index.js';
import Sustainability from './pages/Sustainability/index.js';
import OurCoffee from './pages/OurCoffee/index.js';
import ValueAddition from './pages/ValueAddition/index.js';
import AlphabetGallery from './pages/AlphabetGallery/index.js';
import Blog from './pages/Blog/index.js';
import BlogPost from './pages/BlogPost/index.js';

function App() {
  return (
    <Router>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/coffee" element={<OurCoffee />} />
        <Route path="/value" element={<ValueAddition />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="/sustainability" element={<Sustainability />} />
        <Route path="/gallery" element={<AlphabetGallery />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<BlogPost />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;
